import { Button, Modal } from "react-bootstrap";
import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import {
  addCreate,
  addUpdate,
  addusers,
  findAllRoles,
  findallspokes,
  getallAdditionalbranch,
  getallbranch,
  getallregion,
  getallstates,
  getallzones,
  getuserbyid,
  getClassifications,
} from "../../../Utils/Services/employeeMaster";
import {
  checkIfNotDecimal,
  formatIndianCurrency,
  replaceComma,
} from "../../../Utils/helperFunctions";
import { cloneDeep, result } from "lodash";

import CloseModal from "../../../Components/CloseModal";
import Select from "react-select";
import { configureStore } from "../../../store";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

toast.configure();

const initForm = {
  vertical: null,
  employeeName: "",
  employeeFirstName: "",
  employeeLastName: "",
  employeeId: "",
  emailId: "",
  mobileNo: "",
  role: "",
  status: "ACTIVE",
  zoneDTO: {
    id: "",
    zoneName: "",
  },
  stateDTO: {
    id: "",
    stateName: "",
  },
  regionDTO: {
    id: "",
    regionName: "",
  },
  additionalRegionDTO: [],
  branchDTO: {
    id: "",
    branchName: "",
  },
  nonPrimaryBranchSet: null,
  spokeDTOSet: [{}],
  joiningDate: "",
  lastWorkingDate: "",
  department: "",
  designation: "",
  remarks: "",
  location: "",
  classification: null,

  errors: {
    employeeName: null,
    employeeFirstName: null,
    employeeLastName: null,
    employeeId: null,
    emailId: null,
    mobileNo: null,
    role: null,
    zoneDTO: null,
    stateDTO: null,
    branchDTO: null,
    vertical: null,
    joiningDate: null,
    lastWorkingDate: null,
    department: null,
    designation: null,
    remarks: null,
    location: null,
  },
  status: "ACTIVE",
};

const statusType = [
  { statusLabel: "ACTIVE", statusValue: "ACTIVE" },
  { statusLabel: "INACTIVE", statusValue: "INACTIVE" },
];

const verticalDropdown = [
  { verticalLabel: "SarvaGram Solutions", verticalValue: "solutions" },
  { verticalLabel: "SarvaGram Fincare", verticalValue: "fincare" },
];

const dropstyle = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};

export class Addedituser extends Component {
  state = {
    showModal: false,
    isLoading: false,
    showInner: false,
    form: cloneDeep(initForm),
    key: Math.random(),
    userBranch: [],
    userZone: [],
    userState: [],
    userRegion: [],
    userVillage: [],
    zoneDropdownValue: [],
    stateDropdownValue: [],
    branchDropdownValue: [],
    branchAdditinalDropdownValue: [],
    regionDropdownValue: [],
    additionalRegionDropdownValue: [],
    villageDropdownValue: [],
    classificationDropdownValue: [],
    spokesList: [],
    loaderForSpoke: false,
    showZone: false,
    showState: false,
    showRegion: false,
    showAdditionalRegion: false,
    showBranch: false,
    showSpoke: false,
    showUpdate: true,
    showGeography: false,
  };

  componentDidMount = () => {
    let {
      form,
      obj1,
      zoneDropdownValue,
      stateDropdownValue,
      regionDropdownValue,
      branchDropdownValue,
      branchAdditinalDropdownValue,
      villageDropdownValue,
      spokesList,
    } = this.state;
    let { editData } = this.props;
    this.setState({ showModal: true });
    if (this.props.editData && this.props.action == "edit") {
      this.props.editData.oldRole = this.props.editData.role;

      let { form, showZone, showRegion, showBranch, showSpoke, showState } =
        this.state;

      let obj = {
        ...form,
        ...this.props.editData,
      };

      let { roleDropdownValue } = this.props;

      var geography = null;
      roleDropdownValue.forEach((roleDropdown) => {
        if (roleDropdown.roleName === obj.role) {
          geography = roleDropdown.geography;
        }
      });

      this.getuser(this.props.editData.id);

      if (editData.emailId) {
        const [username, domain] = editData.emailId.split("@");
        obj.emailId = username;
        obj.selectedDomain = `@${domain}`;
      } else {
        obj.emailId = "";
        obj.selectedDomain = "";
      }

      let indexNew =
        editData &&
        editData.village &&
        editData.village.findIndex((e) => e.villageName === "All");
      let userVillage1 = [];
      if (indexNew > -1) {
        userVillage1.push(
          editData &&
          editData.village &&
          editData.village.filter((e) => e.villageName === "All")
        );
      }
      let newdata =
        userVillage1 && userVillage1.length > 0
          ? userVillage1[0]
          : editData.village;

      newdata &&
        newdata.map((e) => {
          e.id = e.pincodeVillageMappingId;
        });

      this.setShowGeography(geography);

      this.setState({
        form: obj,
        userVillage: newdata,
        key: Math.random(),
      });
    }
    if (this.props && this.props.action == "add") this.getzones();
    this.loadClassifications();
  };

  loadClassifications = () => {
    getClassifications().then((result) => {
      if (result.error || result.data?.error) {
        return;
      }
      const list = result.data?.result || [];
      const options = [
        { value: null, label: "--Select--" },
        ...list.map((c) => ({ value: c, label: c })),
      ];
      this.setState({ classificationDropdownValue: options });
    });
  };

  getzones = () => {
    getallzones().then((result) => {
      if (result.error) {
      } else if (result.data && result.data.error) {
      } else {
        if (result && result.data) {
          this.setState({
            zoneDropdownValue: result && result.data,
          });
        }
      }
    });
  };

  getstates = (id) => {
    let { form } = this.state;
    if (id === null) {
      return;
    } else
      getallstates(id).then((result) => {
        if (result.error) {
        } else if (result && result.error) {
          toast.error("states not found", {
            type: toast.TYPE.ERROR,
            autoClose: 2000,
          });
        } else {
          if (result && result.data) {
            this.setState({
              stateDropdownValue: result && result.data,
            });
          }
        }
      });
  };

  getregions = (id) => {
    let { form } = this.state;
    if (id === null) {
      return;
    } else
      getallregion(id).then((result) => {
        if (result.error) {
        } else if (result.data && result.data.error) {
        } else {
          if (result && result.data) {
            this.setState({
              regionDropdownValue: result && result.data,
            }, () => {
              // Update additional region options when regions are loaded
              this.updateAdditionalRegionOptions();
            });
          }
        }
      });
  };

  getAdditionalbranches = (id) => {
    let { form } = this.state;
    if (id === null) {
      return;
    } else
      getallAdditionalbranch(id).then((result) => {
        if (result && result.error) {
          toast.error(result.data.message, {
            type: toast.TYPE.ERROR,
            autoClose: 2000,
          });
        } else {
          if (result && result.data) {
            this.setState({
              branchAdditinalDropdownValue: result && result.data,
            });
          }
        }
      });
  };
  getbranches = (id) => {
    let { form } = this.state;
    if (id === null) {
      return;
    } else
      getallbranch(id).then((result) => {
        if (result.error) {
        } else if (result && result.error) {
        } else {
          if (this.state.form.role === "RFM") {
            const rfmData = [];
            if (this.state.branchDropdownValue.length > 1) {
              this.setState((prevState) => ({
                branchDropdownValue: Array.isArray(result.data)
                  ? [...prevState.branchDropdownValue, ...result.data]
                  : [...prevState.branchDropdownValue, result.data],
              }));
            } else {
              this.setState({
                branchDropdownValue: result && result.data,
              });
            }
          } else if (result && result.data) {
            this.setState({
              branchDropdownValue: result && result.data,
            });
          }
        }
      });
  };

  getspokes = (id) => {
    let { form } = this.state;
    if (id === null) {
      return;
    } else
      findallspokes(id).then((result) => {
        if (result.error) {
        } else if (result && result.error) {
        } else {
          if (result && result.data) {
            let { form, villageDropdownValue } = this.state;
            villageDropdownValue = [];
            this.setState({
              villageDropdownValue: result && result.data,
            });
          }
        }
      });
  };

  getuser = (obj) => {
    let { form } = this.state;
    getuserbyid(obj).then((res) => {
      if (res.error) {
        return;
      }
      if (res && res.error) {
        toast.error(res.message, {
          type: toast.TYPE.ERROR,
          autoClose: 2000,
        });
      } else {
        let { form, obj1 } = this.state;
        form.vertical = res && res.data && res.data.vertical;
        form.employeeFirstName = res && res.data && res.data.employeeFirstName;
        form.joiningDate = res && res.data && res.data.joiningDate;
        form.lastWorkingDate = res && res.data && res.data.lastWorkingDate;
        form.department = res && res.data && res.data.department;
        form.designation = res && res.data && res.data.designation;
        form.remarks = res && res.data && res.data.remarks;
        form.classification = res?.data?.classification;
        // Backend may return location as null, undefined, or empty string
        form.location = res?.data?.location != null && res.data.location !== "" ? res.data.location : "";
        form.employeeLastName = res && res.data && res.data.employeeLastName;

        if (res && res.data && res.data.spokeDTOSet != null)
          form.spokeDTOSet = res && res.data && res.data.spokeDTOSet;

        if (res && res.data && res.data.nonPrimaryBranchSet != null)
          form.nonPrimaryBranchSet =
            res && res.data && res.data.nonPrimaryBranchSet;
        if (res && res.data && res.data.branchDTO != null)
          form.branchDTO = res && res.data && res.data.branchDTO;
        if (res && res.data && res.data.branchDTO == null)
          form.branchDTO = { id: "", branchName: "" };

        if (res && res.data && res.data.regionDTO != null) {
          form.regionDTO = res && res.data && res.data.regionDTO;
        }
        if (res && res.data && res.data.regionDTO == null)
          form.regionDTO = { id: "", regionName: "" };

        if (res && res.data && res.data.nonPrimaryRegionSet != null) {
          form.additionalRegionDTO = res && res.data && res.data.nonPrimaryRegionSet;
        }
        if (res && res.data && res.data.nonPrimaryRegionSet == null)
          form.additionalRegionDTO = [];

        if (res && res.data && res.data.stateDTO != null)
          form.stateDTO = res && res.data && res.data.stateDTO;

        if (res && res.data && res.data.zoneDTO != null)
          form.zoneDTO = res && res.data && res.data.zoneDTO;

        this.getzones();
        if (form && form.spokeDTOSet !== null) {
          this.getspokes(form && form.branchDTO && form.branchDTO.id);
        }
        if (form && form.branchDTO && form.branchDTO.id !== "") {
          this.getbranches(form && form.regionDTO && form.regionDTO.id);
        }
        if (form && form.regionDTO && form.regionDTO.id !== "") {
          this.getregions(form && form.stateDTO && form.stateDTO.id);
          this.getAdditionalbranches(
            form && form.stateDTO && form.stateDTO.stateName
          );
        }
        if (form && form.stateDTO && form.stateDTO.id !== "") {
          this.getstates(form && form.zoneDTO && form.zoneDTO.id);
        }

        this.setState({ form, obj1 }, () => {
          // Update additional region options after form is set
          if (form.regionDTO && form.regionDTO.id) {
            this.updateAdditionalRegionOptions();
          }
        });
      }
    });
  };

  getvillage = () => {
    let { form, loaderForSpoke } = this.state;
    let obj = {
      zoneName: form.zoneDTO,
      stateName: form.stateDTO,
      regionName: form.regionDTO,
      branchName: form.branchDTO,
    };
    this.setState({ loaderForSpoke: true });
    findallspokes(obj).then((result) => {
      if (result.error) {
        this.setState({ loaderForSpoke: false });
        return;
      } else if (result.data && result.data.error) {
        this.setState({ loaderForSpoke: false });
      } else {
        if (result && result.data && result.data.data) {
          this.setState({ loaderForSpoke: false });
          let villagedropdown = result.data.data;
          villagedropdown.forEach((res) => {
            if (res.villageName === "All") {
              res.info = `${res.villageName}`;
            } else {
              res.info = `${res.villageName}` + `(${res.pincode})`;
            }
          });
          this.setState({
            villageDropdownValue: villagedropdown,
          });
        }
      }
    });
  };

  handleModalClose = () => {
    this.setState({ showInner: !this.state.showInner });
  };

  innerModalClose = (modclose) => {
    if (!modclose) {
      this.handleModalClose();
    }
    this.setState({ showModal: false });
    if (this.props.action == "edit") {
      this.props.handleEditUser();
    } else {
      this.props.handleAddUser();
    }
  };

  handleSubmit = () => {
    let {
      form,
      userBranch,
      userZone,
      userState,
      userRegion,
      userVillage,
      villageDropdownValue,
    } = this.state;
    let { editData } = this.props;
    const selectedBranch = (this.state.branchDropdownValue || []).find(
      (b) =>
        b.id === form.branchDTO.id ||
        b.branchName === form.branchDTO.branchName
    );
    let employeeCreationFrom = {
      id: form.id,
      vertical: form.vertical,
      employeeName: form.employeeName,
      employeeFirstName: form.employeeFirstName,
      joiningDate: form.joiningDate,
      lastWorkingDate: form.lastWorkingDate,
      department: form.department,
      designation: form.designation,
      remarks: form.remarks,
      location: form.location != null ? String(form.location) : "",
      employeeLastName: form.employeeLastName,
      employeeId: form.employeeId,
      emailId:
        form.emailId.trim() === ""
          ? null
          : `${form.emailId}${form.selectedDomain}`,
      mobileNo: form.mobileNo,
      role: form.role,
      oldRole: form.oldRole,
      status: form.status,
      zoneDTO: form.zoneDTO,
      stateDTO: form.stateDTO,
      regionDTO: Array.isArray(form.regionDTO)
        ? form.regionDTO
        : [form.regionDTO],
      nonPrimaryRegionSet: form.additionalRegionDTO || [],
      branchDTO: {
        id: form.branchDTO.id,
        branchName: form.branchDTO.branchName,
        isSplitEnabled:
          selectedBranch?.isSplitEnabled ??
          form.branchDTO.isSplitEnabled ??
          false,
      },
      nonPrimaryBranchSet: form.nonPrimaryBranchSet,
      spokeDTOSet: form.spokeDTOSet,
      classification: form.classification,
    };
    employeeCreationFrom.role =
      employeeCreationFrom.role === "BCM1"
        ? "BCM 1"
        : employeeCreationFrom.role;

    let obj = cloneDeep(employeeCreationFrom);
    if (Array.isArray(obj.regionDTO)) {
      obj.regionDTO = obj.regionDTO[0];
    }

    delete obj.errors;
    delete obj.zone;
    delete obj.region;

    this.setState({ isLoading: true });
    if (this.props.action == "edit") {
      addUpdate(obj).then((response) => {
        this.setState({ isLoading: false });
        if (response && response.error === true) {
          // Error toast is already shown by httpInterceptor.handleError
          return;
        } else {
          this.props.allusers();
          if (this.props.editData && this.props.action == "edit") {
            this.props.handleEditUser();
            toast.success("Data Updated successfully", {
              type: toast.TYPE.SUCCESS,
              autoClose: 2000,
            });
          } else {
            this.props.handleAddUser();
            toast.success("Data Added successfully", {
              type: toast.TYPE.SUCCESS,
              autoClose: 2000,
            });
          }
        }
      });
    } else {
      addCreate(obj).then((response) => {
        this.setState({ isLoading: false });

        if (response && response.error === true) {
          // Error toast is already shown by httpInterceptor.handleError
          return;
        } else {
          this.props.allusers();
          if (this.props.editData && this.props.action == "edit") {
            this.props.handleEditUser();
            toast.success("Data Updated successfully", {
              type: toast.TYPE.SUCCESS,
              autoClose: 2000,
            });
          } else {
            this.props.handleAddUser();
            toast.success("Data Added successfully", {
              type: toast.TYPE.SUCCESS,
              autoClose: 2000,
            });
          }
        }
      });
    }
  };

  handleMultiSelectChange = (selectedOptions, name) => {
    const selectedValues = selectedOptions.map((opt) => opt.value).join(",");
    const { form } = this.state;
    form[name] = selectedValues;
    this.setState({ form, showUpdate: false });
  };

  handleInputChange = (e, name) => {
    let { form } = this.state;
    if (name === "emailId") {
      const username = e.target.value.split("@")[0];
      form[name] = username;
    } else if (name === "department") {
      form[name] = e.value;
    } else if (name === "location") {
      form[name] = e.target.value.replace(/[^a-zA-Z ]/g, "");
    } else {
      form[name] = e.target.value;
    }
    
    // Auto-populate email when employeeId changes and role is BRO or CO
    if (name === "employeeId" && form.role) {
      if (form.role === "BRO" && form[name]) {
        form.emailId = `bro.${form[name]}`;
        form.selectedDomain = "@sarvagram.in";
      } else if (form.role === "CO" && form[name]) {
        form.emailId = `co.${form[name]}`;
        form.selectedDomain = "@sarvagram.in";
      }
    }
    
    this.setState({ form });

    this.setState({ form, showUpdate: false });
  };

  handleroleSelectChange = (e, name) => {
    this.clearZone();
    this.clearState();
    this.clearRegion();
    this.clearAdditionalRegion();
    this.clearBranch();
    this.clearSpoke();
    this.getzones();

    let { form } = this.state;
    let { roleName, geography } = e;
    form[name] = e.roleCode;

    form.zone = "";

    this.setShowGeography(geography);
    // Auto-populate email when role is BRO or CO and employeeId exists
    if (e.roleCode === "BRO" && form.employeeId) {
      form.emailId = `bro.${form.employeeId}`;
      form.selectedDomain = "@sarvagram.in";
    } else if (e.roleCode === "CO" && form.employeeId) {
      form.emailId = `co.${form.employeeId}`;
      form.selectedDomain = "@sarvagram.in";
    }
    this.setState({ form });

    this.setState({ showUpdate: true });
  };

  setShowGeography = (geography) => {
    let {
      showZone,
      showRegion,
      showAdditionalRegion,
      showBranch,
      showSpoke,
      showGeography,
      showState,
    } = this.state;

    if (geography === null || geography === undefined || geography === "") {
      showGeography = true;
    } else {
      showGeography = false;
    }

    if (geography !== "Nation") {
      showZone = true;
    } else {
      showZone = false;
    }

    if (geography !== "Nation" && geography !== "Zone") {
      showState = true;
    } else {
      showState = false;
    }

    if (
      geography !== "Nation" &&
      geography !== "Zone" &&
      geography !== "State"
    ) {
      showRegion = true;
    } else {
      showRegion = false;
    }

    // Show additional region field when geography is "Region"
    if (geography === "Region") {
      showAdditionalRegion = true;
    } else {
      showAdditionalRegion = false;
    }

    if (
      geography !== "Nation" &&
      geography !== "Zone" &&
      geography !== "State" &&
      geography !== "Region"
    ) {
      showBranch = true;
    } else {
      showBranch = false;
    }

    if (
      geography !== "Nation" &&
      geography !== "Zone" &&
      geography !== "State" &&
      geography !== "Region" &&
      geography !== "Branch"
    ) {
      showSpoke = true;
    } else {
      showSpoke = false;
    }

    if (geography == "" || geography == null || geography == undefined) {
      return;
    }

    this.setState({
      showGeography,
      showZone,
      showState,
      showRegion,
      showAdditionalRegion,
      showBranch,
      showSpoke,
    });
  };

  handleZoneSelectChange = (e, name) => {
    this.clearState();
    this.clearRegion();
    this.clearBranch();
    this.clearSpoke();

    let { form, zoneDropdownValue, showZone } = this.state;
    let { zoneName } = e;
    for (var i = 0; i < zoneDropdownValue.length; i++) {
      if (zoneDropdownValue[i].zoneName == zoneName) {
        form.zoneDTO.id = zoneDropdownValue[i].id;
      }
    }

    form.zoneDTO.zoneName = zoneName;
    if (
      ((form && form.zoneDTO.zoneName === "") ||
        form.zoneDTO.zoneName === null ||
        form.zoneDTO.zoneName === undefined) &&
      showZone
    ) {
      if (form && form.errors) {
        form.errors[name] = true;
        this.setState({ form });
      }
    } else {
      if (form && form.errors) {
        form.errors[name] = false;
        this.setState({ form });
      }
    }
    this.setState({ form, key: Math.random() });

    this.getstates(form.zoneDTO.id);
  };
  handleStateSelectChange = (e, name) => {
    this.clearRegion();
    this.clearBranch();

    let { form, stateDropdownValue, showstate } = this.state;
    let { stateName } = e;
    for (var i = 0; i < stateDropdownValue.length; i++) {
      if (stateDropdownValue[i].stateName == stateName) {
        form.stateDTO.id = stateDropdownValue[i].id;
      }
    }
    form.stateDTO.stateName = stateName;
    if (
      form &&
      (form.stateDTO.stateName === "" ||
        form.stateDTO.stateName === null ||
        form.stateDTO.stateName === undefined) &&
      showstate
    ) {
      if (form && form.errors) {
        form.errors[name] = true;
        this.setState({ form });
      }
    } else {
      if (form && form.errors) {
        form.errors[name] = false;
        this.setState({ form });
      }
    }
    this.setState({ form, key: Math.random() });
    this.clearAllRegion();
    this.getregions(form.stateDTO.id);
    this.getAdditionalbranches(form.stateDTO.stateName);
  };

  handleRegionSelectChange = (e, name) => {
    const isRFM = this.state.form.role;
    if (isRFM === "RFM") {
      const selectedRegions = e.map((region) => ({
        id: region.id,
        regionName: region.regionName,
      }));
      this.setState((prevState) => ({
        form: {
          ...prevState.form,
          regionDTO: selectedRegions,
        },
      }));
      selectedRegions.forEach((region) => {
        this.getbranches(region.id);
      });
      return;
    }
    this.clearBranch();
    this.clearAllRegion();
    this.clearSpoke();
    this.clearAdditionalRegion();
    let {
      form,
      regionDropdownValue,
      showZone,
      showRegion,
      showBranch,
      showSpoke,
    } = this.state;
    let { regionName } = e;
    for (var i = 0; i < regionDropdownValue.length; i++) {
      if (regionDropdownValue[i].regionName == regionName) {
        form.regionDTO.id = regionDropdownValue[i].id;
      }
    }
    form.regionDTO.regionName = regionName;
    if (
      form &&
      (form.regionDTO.regionName === "" ||
        form.regionDTO.regionName === null ||
        form.regionDTO.regionName === undefined) &&
      showRegion
    ) {
      if (form && form.errors) {
        form.errors[name] = true;
        this.setState({ form });
      }
    } else {
      if (form && form.errors) {
        form.errors[name] = false;
        this.setState({ form });
      }
    }
    this.setState({ form, key: Math.random() });
    this.clearAllBranch();
    this.getbranches(form.regionDTO.id);

    // Filter additional regions - show regions that are not selected
    this.updateAdditionalRegionOptions();
  };

  handleBranchSelectChange = (e, name) => {
    this.clearSpoke();
    let {
      form,
      branchDropdownValue,
      showZone,
      showRegion,
      showBranch,
      showSpoke,
    } = this.state;
    let { branchName } = e;
    for (var i = 0; i < branchDropdownValue.length; i++) {
      if (branchDropdownValue[i].branchName == branchName) {
        branchDropdownValue[i].branchMappingEntitySet = "";
        form.branchDTO = branchDropdownValue[i];
      }
    }
    form.branchDTO.branchName = branchName;
    if (
      form &&
      (form.branchDTO.branchName === "" ||
        form.branchDTO.branchName === null ||
        form.branchDTO.branchName === undefined) &&
      showBranch
    ) {
      if (form && form.errors) {
        form.errors[name] = true;
        this.setState({ form });
      }
    } else {
      if (form && form.errors) {
        form.errors[name] = false;
        this.setState({ form });
      }
    }

    this.setState({ form });
    this.getspokes(form.branchDTO.id);
  };

  handleVillage = (village) => {
    let { userVillage, villageDropdownValue } = this.state;

    let { form, showSpoke } = this.state;

    this.setState({ form });

    form.spokeDTOSet = village;
    this.setState({ form });
  };

  handleAdditionalBranches = (village) => {
    let { userVillage, villageDropdownValue } = this.state;
    let { form, showSpoke } = this.state;
    this.setState({ form });
    form.nonPrimaryBranchSet = village;
    this.setState({ form });
  };

  handleAdditionalRegionSelectChange = (selectedRegions) => {
    let { form } = this.state;
    form.additionalRegionDTO = selectedRegions || [];
    this.setState({ form }, () => {
      // Update the available options after selection changes
      this.updateAdditionalRegionOptions();
    });
  };

  updateAdditionalRegionOptions = () => {
    const { regionDropdownValue, form } = this.state;
    const selectedRegionId = form.regionDTO.id;
    const alreadySelectedRegionIds = form.additionalRegionDTO.map(region => region.id);

    // If no region is selected yet, show all regions
    if (!selectedRegionId) {
      this.setState({
        additionalRegionDropdownValue: regionDropdownValue,
      });
      return;
    }

    // Filter out the selected region and already selected additional regions from the available options
    const additionalRegionOptions = regionDropdownValue.filter(
      (region) => region.id !== selectedRegionId && !alreadySelectedRegionIds.includes(region.id)
    );

    this.setState({
      additionalRegionDropdownValue: additionalRegionOptions,
    });
  };

  handleVerticalChange = (e, name) => {
    let { form } = this.state;
    form.vertical = e?.verticalValue;
    this.setState({ form });
  };

  handleClassificationChange = (e) => {
    let { form } = this.state;
    form.classification = e ? e.value : null;
    this.setState({ form });
  };

  onValidate = (e, name) => {
    e.preventDefault();
    let { form } = this.state;
    if (name === "employeeFirstName") {
      const value = form[name];
      const hasLeadingOrTrailingSpace = /^\s|\s$/.test(value);
      const isValidChars = /^[a-zA-Z]+$/.test(value.trim());

      if (value.trim() === "") {
        form.errors[name] = "Employee First Name is required";
      } else if (hasLeadingOrTrailingSpace) {
        form.errors[name] = "First Name should not start or end with spaces";
      } else if (!isValidChars) {
        form.errors[name] = "First Name should only contain alphabets";
      } else {
        form.errors[name] = false;
      }
    } else if (name === "employeeLastName") {
      const value = form[name];
      const hasLeadingOrTrailingSpace = /^\s|\s$/.test(value);
      const isValidChars = /^[a-zA-Z]+$/.test(value.trim());

      if (value.trim() === "") {
        form.errors[name] = "Employee Last Name is required";
      } else if (hasLeadingOrTrailingSpace) {
        form.errors[name] = "Last Name should not start or end with spaces";
      } else if (!isValidChars) {
        form.errors[name] = "Last Name should only contain alphabets";
      } else {
        form.errors[name] = false;
      }
    } else if (name === "employeeId") {
      const value = form[name];

      if (value.trim() === "") {
        form.errors[name] = "Employee ID is required";
      } else if (!/^[A-Z0-9]+$/.test(value)) {
        form.errors[name] =
          "Employee ID should only contain uppercase letters and numbers";
      } else {
        form.errors[name] = false;
      }
    } else if (["department", "designation", "remarks", "location"].includes(name)) {
      const value = form[name];

      if (name === "location") {
        const loc = value != null ? String(value).trim() : "";
        if (loc === "") {
          form.errors[name] = "Location is required";
        } else if (!/^[a-zA-Z ]+$/.test(loc)) {
          form.errors[name] = "Location should only contain alphabets and spaces";
        } else {
          form.errors[name] = false;
        }
      } else if (name === "remarks") {
        if (value.trim() === "") {
          form.errors[name] = "Remarks are required";
        } else if (value.length > 500) {
          form.errors[name] = "Remarks cannot exceed 500 characters";
        } else {
          form.errors[name] = false;
        }
      } else if (name === "department") {
        if (!value || value.trim() === "") {
          form.errors[name] = "Department is required";
        } else {
          const values = value
            .split(",")
            .map((v) => v.trim())
            .filter(Boolean);
          if (values.length === 0) {
            form.errors[name] = "Department is required";
          } else {
            form.errors[name] = false;
          }
        }
      } else if (name === "designation") {
        if (value.trim() === "") {
          form.errors[name] = `${name} is required`;
        } else if (/^\s|\s$/.test(value)) {
          form.errors[name] = `${name} should not start or end with spaces`;
        } else if (!/^[a-zA-Z ]+$/.test(value)) {
          form.errors[
            name
          ] = `${name} should only contain alphabets and spaces`;
        } else if (value.length > 100) {
          form.errors[name] = `${name} cannot exceed 100 characters`;
        } else {
          form.errors[name] = false;
        }
      }
    } else if (name === "emailId") {
      if (form.emailId.trim() === "") {
        form.errors[name] = false;
      } else {
        const email = `${form.emailId}${form.selectedDomain}`;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        form.errors[name] = !emailRegex.test(email);
      }
    } else if (name === "mobileNo") {
      if (form[name].trim() === "" || !/^[6789]\d{9}$/.test(form[name])) {
        form.errors[name] = true;
      } else form.errors[name] = false;
    } else if (name === "role") {
      if (form[name] === "") {
        form.errors[name] = true;
      } else form.errors[name] = false;
    } else if (name === "spokeDTOSet") {
      if (form[name] === null) {
        form.errors["spokeDTO"] = true;
      } else form.errors["spokeDTO"] = false;
    } else {
      if (form[name].id === null) {
        form.errors[name] = true;
      } else form.errors[name] = false;
    }

    this.setState({ form });
  };

  handleSelectChanges = (e, name) => {
    let { form } = this.state;
    let { statusValue } = e;
    form[name] = statusValue;
    this.setState({ form });
    this.setState({ showUpdate: false });
  };

  clearAllBranch = () => {
    let { form } = this.state;
    form.branchDTO = { branchName: "", id: "" };
    this.setState({ form });
  };
  clearAllRegion = () => {
    let { form } = this.state;
    form.region = "";
    this.setState({ form });
  };

  clearState = () => {
    let { form, stateDropdownValue } = this.state;
    form.stateDTO = { id: "", stateName: "" };

    this.setState({
      form,
      stateDropdownValue: [],
    });
  };

  clearRegion = () => {
    let { form, regionDropdownValue } = this.state;
    form.regionDTO = {
      id: "",
      regionName: "",
    };

    this.setState({
      form,
      regionDropdownValue: [],
    });
  };

  clearAdditionalRegion = () => {
    let { form, additionalRegionDropdownValue } = this.state;
    form.additionalRegionDTO = [];

    this.setState({
      form,
      additionalRegionDropdownValue: [],
    });
  };

  clearBranch = () => {
    let { form, branchDropdownValue } = this.state;
    form.branchDTO = {
      id: "",
      branchName: "",
    };

    this.setState({
      form,
      branchDropdownValue: [],
    });
  };

  clearSpoke = () => {
    let { form, villageDropdownValue } = this.state;
    form.spokeDTOSet = null;
    this.setState({
      form,
      villageDropdownValue: [],
    });
  };
  clearZone = () => {
    let { form, zoneDropdownValue } = this.state;
    form.zoneDTO.id = "";
    form.zoneDTO.zoneName = "";
    this.setState({
      form,
      zoneDropdownValue: [],
    });
  };

  render() {
    let {
      form,
      showModal,
      showInner,
      isLoading,
      userBranch,
      userZone,
      userState,
      userRegion,
      userVillage,
      key,
      zoneDropdownValue,
      stateDropdownValue,
      regionDropdownValue,
      additionalRegionDropdownValue,
      branchDropdownValue,
      branchAdditinalDropdownValue,
      villageDropdownValue,
      classificationDropdownValue,
      loaderForSpoke,
      showZone,
      showState,
      showRegion,
      showAdditionalRegion,
      showBranch,
      showSpoke,
      showUpdate,
      showGeography,
    } = this.state;
    let { roleDropdownValue, role, userInfo } = this.props;
    let { errors } = form;
    let diableSave = false;
    let isRequiredFeildFilled = false; 
    const departmentOptions = [
      { label: "COLLECTION", value: "COLLECTION" },
      { label: "COMPLIANCE", value: "COMPLIANCE" },
      { label: "CREDIT", value: "CREDIT" },
      { label: "CUSTOMER SERVICE", value: "CUSTOMER SERVICE" },
      { label: "FARM MECH", value: "FARM MECH" },
      { label: "FINANCE AND CONTROL", value: "FINANCE AND CONTROL" },
      { label: "FOUNDER OFFICE", value: "FOUNDER OFFICE" },
      { label: "HR", value: "HR" },
      { label: "INFRA AND ADMIN", value: "INFRA AND ADMIN" },
      { label: "INSURANCE", value: "INSURANCE" },
      { label: "INTERNAL AUDIT", value: "INTERNAL AUDIT" },
      { label: "IT", value: "IT" },
      { label: "MARKETING", value: "MARKETING" },
      { label: "OPERATIONS", value: "OPERATIONS" },
      { label: "RISK", value: "RISK" },
      { label: "SALES", value: "SALES" },
      { label: "STRATEGY", value: "STRATEGY" },
      { label: "WCC", value: "WCC" },
    ];


    let villageobj = [];
    villageDropdownValue &&
      villageDropdownValue.map((res) => {
        userVillage &&
          userVillage.map((val) => {
            if (res.id == val.id) {
              villageobj.push(res);
            }
          });
      });

    Object.keys(errors).map((error) => {
      if (errors[error] == true) {
        diableSave = true;
        return true;
      }
    });

    if (zoneDropdownValue.length > 0) {
      if (
        role === "ZBH" ||
        role === "ZCM" ||
        role === "RBH" ||
        role === "RCM" ||
        role === "BM"
      ) {
        zoneDropdownValue =
          (zoneDropdownValue &&
            zoneDropdownValue.filter((e) =>
              e.zonename.includes(userInfo.zone)
            )) ||
          [];
      }
    }

    if (regionDropdownValue.length > 0) {
      if (role === "RBH" || role === "RCM" || role === "BM") {
        regionDropdownValue =
          (regionDropdownValue &&
            regionDropdownValue.filter((e) =>
              e.regionName.includes(userInfo.region)
            )) ||
          [];
      }
    }

    if (branchDropdownValue.length > 0) {
      if (role === "BM") {
        branchDropdownValue =
          (branchDropdownValue &&
            branchDropdownValue.filter((e) =>
              e.branchName.includes(userInfo.branch)
            )) ||
          [];
      }
    }

    if (branchAdditinalDropdownValue.length > 0) {
      if (role === "BM") {
        branchAdditinalDropdownValue =
          (branchAdditinalDropdownValue &&
            branchAdditinalDropdownValue.filter((e) =>
              e.branchName.includes(userInfo.branch)
            )) ||
          [];
      }
    }

    const isNullOrEmpty = (v) => v === "" || v === null || v === undefined;

    const requiredFieldsAdd = [
      "vertical",
      "employeeFirstName",
      "employeeLastName",
      "mobileNo",
      "joiningDate",
      "department",
      "designation",
      "remarks",
      "location",
      "role",
      "emailId",
    ];

    const requiredFieldsEdit = [
      "vertical",
      "employeeFirstName",
      "employeeLastName",
      "mobileNo",
      "id",
      "joiningDate",
      "department",
      "designation",
      "remarks",
      "location",
      "role",
      "emailId",
    ];

    const geographyFields = [
      { key: "branchDTO", show: showBranch },
      { key: "regionDTO", show: showRegion },
      { key: "stateDTO", show: showState },
      { key: "zoneDTO", show: showZone },
    ];

    const areFieldsInvalid = (fields) =>
      fields.some((field) => isNullOrEmpty(form[field]));

    const areGeographyFieldsInvalid = geographyFields.some(({ key, show }) => {
      if (!show) return false;
      const value = form[key];
      if (Array.isArray(value)) {
        return value.length === 0; 
      }
      return isNullOrEmpty(value?.id);
    });

    const isInactiveWithMissingLastDate =
      this.props.action === "edit" &&
      form["status"] === "INACTIVE" &&
      isNullOrEmpty(form["lastWorkingDate"]?.trim());

    const disabledCheck =
      diableSave ||
      isLoading ||
      (this.props.action === "add" && areFieldsInvalid(requiredFieldsAdd)) ||
      (this.props.action === "add" && areGeographyFieldsInvalid) ||
      (this.props.action === "edit" && areFieldsInvalid(requiredFieldsEdit)) ||
      (this.props.action === "edit" &&
        areGeographyFieldsInvalid &&
        showUpdate) ||
      isInactiveWithMissingLastDate ||
      showGeography;

    return (
      <>
        <Modal
          className="add-role"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showModal}
          dialogClassName="employee-modal-dialog"
        >
          <Modal.Header>
            <Modal.Title>
              {this.props.action == "edit" ? "Edit User" : "Add User"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-4">
            {isLoading ? (
              <h4 className="text-center">LOADING...</h4>
            ) : (
              <>
                <div className="row">
                  <div className="col-md-4 mt-3">
                    <label>
                      <i className="text-danger">*</i> Vertical
                    </label>
                    <Select
                      value={verticalDropdown?.find(
                        ({ verticalValue }) =>
                          verticalValue === this?.state?.form?.vertical
                      )}
                      onChange={(e) => {
                        this.handleVerticalChange(e, "vertical");
                      }}
                      name="vertical"
                      options={verticalDropdown}
                      placeholder="Select Vertical"
                      valueKey="verticalValue"
                      labelKey="verticalLabel"
                      getOptionLabel={(option) => option.verticalLabel}
                      getOptionValue={(option) => option.verticalValue}
                    />
                    {errors.vertical && (
                      <span className="errorMsg">Please Select Vertical</span>
                    )}
                  </div>
                  <div className="col-md-4 mt-3">
                    <div className="form-group">
                      <label>
                        <i className="text-danger">*</i> First Name
                      </label>
                      <div class="inner-addon right-addon">
                        <input
                          type="text"
                          name="employeeFirstName"
                          value={form.employeeFirstName}
                          onChange={(e) => {
                            this.handleInputChange(e, "employeeFirstName");
                          }}
                          onBlur={(e) => {
                            this.onValidate(e, "employeeFirstName");
                          }}
                          placeholder="Enter employeeFirstName"
                          className={`form-input ${errors.employeeFirstName ? "error-input-border" : ""
                            } `}
                        />
                        {errors.employeeFirstName && (
                          <span className="errorMsg">
                            {errors.employeeFirstName == true
                              ? "Enter a valid Employee First Name"
                              : errors.employeeFirstName}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mt-3">
                    <div className="form-group">
                      <label>
                        <i className="text-danger">*</i> Last Name
                      </label>
                      <div class="inner-addon right-addon">
                        <input
                          type="text"
                          name="employeeLastName"
                          value={form.employeeLastName}
                          onChange={(e) => {
                            this.handleInputChange(e, "employeeLastName");
                          }}
                          onBlur={(e) => {
                            this.onValidate(e, "employeeLastName");
                          }}
                          placeholder="Enter employeeLastName"
                          className={`form-input ${errors.employeeLastName ? "error-input-border" : ""
                            } `}
                        />
                        {errors.employeeLastName && (
                          <span className="errorMsg">
                            {errors.employeeLastName == true
                              ? "Enter a valid Employee Name"
                              : errors.employeeLastName}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* emp ID */}
                  <div className="col-md-4 mt-3">
                    <div className="form-group">
                      <label>
                        <i className="text-danger">*</i> Employee ID
                      </label>
                      <div class="inner-addon right-addon">
                        <input
                          type="text"
                          maxLength="10"
                          name="employeeId"
                          value={form && form.employeeId}
                          onChange={(e) => {
                            this.handleInputChange(e, "employeeId");
                          }}
                          onBlur={(e) => {
                            this.onValidate(e, "employeeId");
                          }}
                          placeholder="Enter employeeId"
                          className={`form-input ${errors.employeeId ? "error-input-border" : ""
                            } `}
                          disabled={this.props.action == "edit"}
                        />
                        {errors.employeeId && (
                          <span className="errorMsg">
                            {errors.employeeId == true
                              ? "Enter a valid Employee ID"
                              : errors.employeeId}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mt-3">
                    <div className="form-group">
                      <label>
                        <i className="text-danger">*</i> Mobile Number
                      </label>
                      <div class="inner-addon right-addon">
                        <input
                          type="text"
                          maxLength="10"
                          name="mobileNo"
                          value={form && form.mobileNo}
                          onChange={(e) => {
                            this.handleInputChange(e, "mobileNo");
                          }}
                          onBlur={(e) => {
                            this.onValidate(e, "mobileNo");
                          }}
                          placeholder="Enter Mobile Number"
                          className={`form-input ${errors.mobileNo ? "error-input-border" : ""
                            } `}
                          reqType="number"
                        />
                        {errors.mobileNo && (
                          <span className="errorMsg">
                            {errors.mobileNo == true
                              ? "Enter a valid Mobile Number"
                              : errors.mobileNo}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mt-3">
                    <div className="form-group">
                      <label>
                        <i className="text-danger">*</i> Joining Date
                      </label>
                      <div className="inner-addon right-addon">
                        <input
                          type="date"
                          name="joiningDate"
                          value={form.joiningDate}
                          max={new Date().toISOString().split("T")[0]}
                          onChange={(e) => {
                            this.handleInputChange(e, "joiningDate");
                          }}
                          onBlur={(e) => {
                            this.onValidate(e, "joiningDate");
                          }}
                          placeholder="Enter joiningDate"
                          className={`form-input ${errors.joiningDate ? "error-input-border" : ""
                            }`}
                        />
                        {errors.joiningDate && (
                          <span className="errorMsg">
                            {errors.joiningDate === true
                              ? "Enter a valid Joining Date"
                              : errors.joiningDate}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 mt-3">
                    <label>
                      <i className="text-danger">*</i> Department
                    </label>
                    <Select
                      isMulti
                      name="department"
                      placeholder="Select department(s)"
                      options={departmentOptions}
                      value={departmentOptions?.filter((opt) =>
                        form?.department?.split(",")?.includes(opt.value)
                      )}
                      onChange={(selectedOptions) =>
                        this.handleMultiSelectChange(
                          selectedOptions,
                          "department"
                        )
                      }
                      onBlur={(e) => this.onValidate(e, "department")}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      className={`${errors.department ? "error-input-border" : ""
                        }`}
                    />
                    {errors.department && (
                      <span className="errorMsg">
                        Please select a department
                      </span>
                    )}
                  </div>

                  <div className="col-md-4 mt-3">
                    <div className="form-group">
                      <label>
                        <i className="text-danger">*</i> designation
                      </label>
                      <div class="inner-addon right-addon">
                        <input
                          type="text"
                          maxLength={100}
                          name="designation"
                          value={form.designation}
                          onChange={(e) => {
                            this.handleInputChange(e, "designation");
                          }}
                          onBlur={(e) => {
                            this.onValidate(e, "designation");
                          }}
                          placeholder="Enter designation"
                          className={`form-input ${errors.designation ? "error-input-border" : ""
                            } `}
                        />
                        {errors.designation && (
                          <span className="errorMsg">
                            {errors.designation == true
                              ? "Enter a valid designation"
                              : errors.designation}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 mt-3">
                    <div className="form-group">
                      <label>
                        <i className="text-danger">*</i> Location
                      </label>
                      <div className="inner-addon right-addon">
                        <input
                          type="text"
                          name="location"
                          value={form.location != null ? form.location : ""}
                          onChange={(e) => {
                            this.handleInputChange(e, "location");
                          }}
                          onBlur={(e) => {
                            this.onValidate(e, "location");
                          }}
                          placeholder="Location"
                          className={`form-input ${errors.location ? "error-input-border" : ""}`}
                        />
                        {errors.location && (
                          <span className="errorMsg">
                            {errors.location === true
                              ? "Location is required"
                              : errors.location}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 mt-3">
                    <div className="form-group">
                      <label>
                        <i className="text-danger">*</i> Remarks
                      </label>
                      <div className="inner-addon right-addon">
                        <textarea
                          name="remarks"
                          value={form.remarks}
                          onChange={(e) => {
                            this.handleInputChange(e, "remarks");
                          }}
                          onBlur={(e) => {
                            this.onValidate(e, "remarks");
                          }}
                          placeholder="Enter remarks"
                          className={`form-input ${errors.remarks ? "error-input-border" : ""
                            }`}
                          rows="4"
                          maxLength={500}
                        ></textarea>
                        {errors.remarks && (
                          <span className="errorMsg">
                            {errors.remarks === true
                              ? "Enter a valid remarks"
                              : errors.remarks}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Role */}
                  <div className="col-md-4 mt-3">
                    <label>
                      <i className="text-danger">*</i> Role
                    </label>
                    <Select
                      defaultValue={
                        roleDropdownValue.filter(
                          ({ roleName }) => roleName == form.role
                        )[0]
                      }
                      onChange={(e) => {
                        this.handleroleSelectChange(e, "role");
                      }}
                      onBlur={(e) => this.onValidate(e, "role")}
                      name="role"
                      options={roleDropdownValue}
                      placeholder="Select role"
                      valueKey="roleName"
                      labelKey="roleName"
                      getOptionLabel={(option) => option.roleName}
                      getOptionValue={(option) => option.roleName}
                      className={`${errors.role ? "error-input-border" : ""} `}
                    />
                    {errors.role && (
                      <span className="errorMsg">Please Select Role</span>
                    )}
                  </div>

                  {/* Email Id */}
                  <div className="col-md-4 mt-3">
                    <div className="form-group">
                      <label>
                        <i className="text-danger">*</i> Email ID
                      </label>
                      <div className="inner-addon right-addon d-flex align-items-stretch" style={{ gap: '8px' }}>
                        <input
                          type="text"
                          name="emailId"
                          value={form.emailId}
                          onChange={(e) => {
                            this.handleInputChange(e, "emailId");
                          }}
                          onBlur={(e) => {
                            this.onValidate(e, "emailId");
                          }}
                          placeholder="Enter Email ID"
                          className={`form-input flex-grow-1 ${errors.emailId ? "error-input-border" : ""
                            } `}
                          style={{ flex: '1', height: '42px' }}
                        />
                        <select
                          value={form.selectedDomain}
                          onChange={(e) => {
                            let { form } = this.state;
                            form.selectedDomain = e.target.value;
                            this.setState({ form }, () => {
                              this.onValidate(
                                { preventDefault: () => { } },
                                "emailId"
                              );
                            });
                          }}
                          className="email-domain-select"
                          style={{
                            backgroundColor: "#17a2b8",
                            color: "#fff",
                            border: "1px solid #17a2b8",
                            borderRadius: "5px",
                            padding: "0",
                            fontSize: "16px",
                            fontWeight: "500",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            width: "170px",
                            height: "42px",
                            outline: "none",
                            boxShadow: "0 2px 4px rgba(23, 162, 184, 0.2)",
                            textAlign: "center",
                            textAlignLast: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            lineHeight: "42px",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#138496";
                            e.target.style.borderColor = "#138496";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#17a2b8";
                            e.target.style.borderColor = "#17a2b8";
                          }}
                        >
                          <option value="" style={{ backgroundColor: "#fff", color: "#222", textAlign: "center", padding: "10px" }}>Select Domain</option>
                          <option value="@sarvagram.com" style={{ backgroundColor: "#fff", color: "#222", textAlign: "center", padding: "10px" }}>@sarvagram.com</option>
                          <option value="@sarvagram.in" style={{ backgroundColor: "#fff", color: "#222", textAlign: "center", padding: "10px" }}>@sarvagram.in</option>
                        </select>
                      </div>
                      {errors.emailId && (
                        <div className="errorMsg">
                          {errors.emailId == true
                            ? "Enter a valid Email ID"
                            : errors.emailId}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* status */}
                  {this.props.action == "edit" && (
                    <div className="col-md-4 mt-3">
                      <label>
                        <i className="text-danger">*</i> Status
                      </label>
                      <Select
                        defaultValue={
                          statusType.filter(
                            ({ statusValue }) => statusValue == form.status
                          )[0]
                        }
                        onChange={(e) => {
                          this.handleSelectChanges(e, "status");

                          this.setState((prevState) => ({
                            form: {
                              ...prevState.form,
                              lastWorkingDate: "",
                            },
                          }));
                        }}
                        onBlur={(e) => this.onValidate(e, "status")}
                        name="status"
                        options={statusType}
                        placeholder="Select Status"
                        valueKey="statusLabel"
                        labelKey="statusValue"
                        getOptionLabel={(option) => option.statusValue}
                        getOptionValue={(option) => option.statusLabel}
                        className={`${errors.status ? "error-input-border" : ""
                          } `}
                      />
                      {errors.status && (
                        <span className="errorMsg">Please Select Status</span>
                      )}
                    </div>
                  )}
                  {form.status === "INACTIVE" && (
                    <div className="col-md-4 mt-3">
                      <div className="form-group">
                        <label>
                          <i className="text-danger">*</i> Last working Date
                        </label>
                        <div className="inner-addon right-addon">
                          <input
                            type="date"
                            name="lastWorkingDate"
                            value={form.lastWorkingDate}
                            onChange={(e) => {
                              this.handleInputChange(e, "lastWorkingDate");
                            }}
                            max={new Date().toISOString().split("T")[0]}
                            onBlur={(e) => {
                              this.onValidate(e, "lastWorkingDate");
                            }}
                            placeholder="Enter Last working Date"
                            className={`form-input ${errors.lastWorkingDate ? "error-input-border" : ""
                              }`}
                          />
                          {errors.lastWorkingDate && (
                            <span className="errorMsg">
                              {errors.lastWorkingDate === true
                                ? "Enter a valid Last working Date"
                                : errors.lastWorkingDate}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {showZone &&
                    zoneDropdownValue &&
                    zoneDropdownValue.length > 0 && (
                      <div className="col-md-4 mt-3">
                        <label>
                          <i className="text-danger">*</i> Zone
                        </label>
                        <Select
                          defaultValue={
                            zoneDropdownValue &&
                            zoneDropdownValue.filter(
                              ({ zoneName }) =>
                                zoneName == form.zoneDTO.zoneName
                            )[0]
                          }
                          onChange={(e) => {
                            this.handleZoneSelectChange(e, "zoneDTO");
                          }}
                          name="zoneDTO"
                          options={zoneDropdownValue}
                          placeholder="Select Zone"
                          valueKey="zoneName"
                          labelKey="zoneName"
                          getOptionLabel={(option) => option.zoneName}
                          getOptionValue={(option) => option.zoneName}
                          className={`${errors && errors.zoneDTO ? "error-input-border" : ""
                            } `}
                        />
                        {errors && errors.zoneDTO && (
                          <span className="errorMsg">Please Select Zone</span>
                        )}
                      </div>
                    )}

                  {showState &&
                    stateDropdownValue &&
                    stateDropdownValue.length > 0 && (
                      <div className="col-md-4 mt-3">
                        <label>
                          <i className="text-danger">*</i> State
                        </label>
                        <Select
                          defaultValue={
                            stateDropdownValue &&
                            stateDropdownValue.filter(
                              ({ stateName }) =>
                                stateName == form.stateDTO.stateName
                            )[0]
                          }
                          onChange={(e) => {
                            this.handleStateSelectChange(e, "stateDTO");
                          }}
                          name="state"
                          options={stateDropdownValue}
                          placeholder="Select State"
                          valueKey="stateName"
                          labelKey="stateName"
                          getOptionLabel={(option) => option.stateName}
                          getOptionValue={(option) => option.stateName}
                          className={`${errors && errors.stateDTO
                              ? "error-input-border"
                              : ""
                            } `}
                          key={key}
                        />
                        {errors && errors.stateDTO && (
                          <span className="errorMsg">Please Select State</span>
                        )}
                      </div>
                    )}

                  {/* new Region */}
                  {showRegion &&
                    regionDropdownValue &&
                    regionDropdownValue.length > 0 && (
                      <div className="col-md-4 mt-3">
                        <label>
                          <i className="text-danger">*</i> Region
                        </label>
                        <Select
                          defaultValue={
                            (regionDropdownValue &&
                              regionDropdownValue.filter(
                                ({ regionName }) =>
                                  regionName == form.regionDTO.regionName
                              )) ||
                            ""
                          }
                          onChange={(e) => {
                            this.handleRegionSelectChange(e, "regionDTO");
                          }}
                          name="regionDTO"
                          options={regionDropdownValue}
                          placeholder="Select Region"
                          valueKey="regionName"
                          labelKey="regionName"
                          getOptionLabel={(option) => option.regionName}
                          getOptionValue={(option) => option.regionName}
                          className={`${errors && errors.regionDTO
                              ? "error-input-border"
                              : ""
                            } `}
                          key={key}
                          isMulti={this.state.form.role === "RFM"}
                        />
                        {errors && errors.regionDTO && (
                          <span className="errorMsg">Please Select Region</span>
                        )}
                      </div>
                    )}

                  {/* Additional Region */}
                  {showAdditionalRegion &&
                    regionDropdownValue &&
                    regionDropdownValue.length > 0 && (
                      <div className="col-md-4 mt-3">
                        <label>Additional Region</label>
                        <Select
                          value={form.additionalRegionDTO}
                          onChange={this.handleAdditionalRegionSelectChange}
                          name="additionalRegionDTO"
                          options={additionalRegionDropdownValue.length > 0 ? additionalRegionDropdownValue : regionDropdownValue}
                          placeholder="Select Additional Regions"
                          valueKey="regionName"
                          labelKey="regionName"
                          getOptionLabel={(option) => option.regionName}
                          getOptionValue={(option) => option.regionName}
                          isMulti={true}
                          key={key}
                        />
                      </div>
                    )}

                  {showBranch &&
                    branchDropdownValue &&
                    branchDropdownValue.length > 0 && (
                      <div className="col-md-4 mt-3">
                        <label>
                          <i className="text-danger">*</i> Branch
                        </label>
                        <Select
                          defaultValue={
                            branchDropdownValue.filter(
                              ({ branchName }) =>
                                branchName == form.branchDTO.branchName
                            )[0] || ""
                          }
                          onChange={(e) => {
                            this.handleBranchSelectChange(e, "branchDTO");
                          }}
                          name="branchDTO"
                          options={branchDropdownValue}
                          placeholder="Select Branch"
                          valueKey="branchName"
                          labelKey="branchName"
                          getOptionLabel={(option) => option.branchName}
                          getOptionValue={(option) => option.branchName}
                          className={`${errors && errors.branchDTO
                              ? "error-input-border"
                              : ""
                            } `}
                          key={key}
                        />
                        {errors && errors.branchDTO && (
                          <span className="errorMsg">Please Select Branch</span>
                        )}
                      </div>
                    )}

                  {showBranch &&
                    branchAdditinalDropdownValue &&
                    branchAdditinalDropdownValue.length > 0 && (
                      <div className="col-md-4 mt-3">
                        <>
                          <label>
                            {this.state.form.role === "RFM"
                              ? "Region Branches"
                              : "State branches"}
                          </label>
                          <Select
                            value={form.nonPrimaryBranchSet}
                            onChange={this.handleAdditionalBranches}
                            name="nonPrimaryBranchSet"
                            options={
                              this.state.form.role === "RFM"
                                ? branchDropdownValue
                                : branchAdditinalDropdownValue
                            }
                            placeholder={`Select ${this.state.form.role === "RFM"
                                ? "Region"
                                : "additional"
                              } branches`}
                            valueKey="branchName"
                            labelKey="branchName"
                            getOptionLabel={(option) => option.branchName}
                            getOptionValue={(option) => option.branchName}
                            isDisabled={false}
                            isMulti={true}
                            key={key}
                          />
                        </>
                        {errors.spokeDTO && (
                          <span className="errorMsg">
                            Please Select{" "}
                            {this.state.form.role === "RFM"
                              ? "Region"
                              : "Additional"}{" "}
                            branches
                          </span>
                        )}
                      </div>
                    )}

                  <div className="col-md-4 mt-3">
                    <label htmlFor="classification-select">Classification</label>
                    <Select
                      inputId="classification-select"
                      value={
                        classificationDropdownValue.find(
                          (o) => o.value === form.classification
                        ) || null
                      }
                      onChange={this.handleClassificationChange}
                      name="classification"
                      options={classificationDropdownValue}
                      placeholder="Select Classification"
                      valueKey="value"
                      labelKey="label"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      key={key}
                    />
                  </div>

                  {showSpoke &&
                    villageDropdownValue &&
                    villageDropdownValue.length > 0 && (
                      <div className="col-md-4 mt-3">
                        {loaderForSpoke ? (
                          <React.Fragment>
                            <i class="fa fa-spinner fa-spin ml-3"></i>
                            <span className="ml-2">Please wait...</span>
                          </React.Fragment>
                        ) : (
                          <>
                            <label>
                              <i className="text-danger"></i> Spoke
                            </label>
                            <Select
                              value={form.spokeDTOSet}
                              onChange={this.handleVillage}
                              name="spokeDTOSet"
                              options={villageDropdownValue}
                              placeholder="Select Village / Spoke"
                              valueKey="spokeName"
                              labelKey="spokeName"
                              getOptionLabel={(option) =>
                                `${option.spokeName} (${option.pincode})`
                              }
                              getOptionValue={(option) => option.spokeName}
                              className={`${errors.spokeDTO ? "error-input-border" : ""
                                } `}
                              isDisabled={false}
                              isMulti={true}
                              key={key}
                            />
                          </>
                        )}
                        {errors.spokeDTO && (
                          <span className="errorMsg">
                            Please Select Village / Spoke
                          </span>
                        )}
                      </div>
                    )}
                </div>
              </>
            )}
            <Modal.Footer>
              <Button className="btn-danger" onClick={this.handleModalClose}>
                Cancel
              </Button>
              {role === "ITADMIN" && (
                <Button
                  className="btn-success"
                  disabled={disabledCheck}
                  onClick={this.handleSubmit}
                >
                  {this.props.action === "edit" ? "Update" : "Create"}
                </Button>
              )}
            </Modal.Footer>
          </Modal.Body>
        </Modal>
        <CloseModal
          show={showInner}
          button2={this.handleModalClose}
          button1={this.innerModalClose}
          title="Do you want to close ?"
        />
      </>
    );
  }
}

export default Addedituser;
